import OrgChart from "@/components/team/OrgChart";

export default function OrgChartPage() {
  return <OrgChart />;
}

